<template>
  <div style="min-height: 92vh">
    <div>
      <h3 v-if="!series">Cupones</h3>
      <h3 v-if="series">
        Series de rondas de golf <selectDepartment></selectDepartment>
      </h3>
      <uv-data-table
        :config="config"
        :data="Cupones"
        :pageRows="15"
        @buttonClick="dtButtonClick"
        @buttonOptClick="optButtonClick"
      ></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Cupones">
      <formCupones
        :series="series"
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </formCupones>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import formCupones from "../Cupones/FormCupones.vue";

export default {
  name: "CuponesCRUD",
  components: {
    modal,
    uvDataTable,
    formCupones,
  },
  props: ["series"],
  data() {
    return {
      Cupones: [],
      MainDepartamento: "",
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      Categories: [],
      editData: [],
      products: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addCupon",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editCupon",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteCupon",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nombre",
            text: "Nombre",
            value: "Nombre",
          },
          {
            title: "Cliente/Agencia",
            dataName: "Mayoristas",
            text: "Cliente/Agencia",
            value: "Mayoristas",
            format: (row) => {
              let cuponMayorista = Object.entries(row["Mayoristas"]);
              let mayorista = this.$pgsHelper.getById(
                this.$store.getters.getMayoristas,
                "id",
                cuponMayorista[0][0]
              );

              return mayorista.Nombre;
            },
          },
          {
            title: "Precio Cupón",
            dataName: "Precio",
            text: "Precio Cupón",
            value: "Precio",
          },
          {
            text: "Moneda",
            value: "Moneda",
          },
          {
            text: "Prod. y Serv.",
            value: "Catalogo", //'Existencia',
            format: (row) => {
              return row["Catalogo"].length;
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addCupon") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.showModal = true;
      }
      if (buttonId == "editCupon") {
        this.formIndex++;
        this.editMode = true;
        let prodEdit = this.$pgsHelper.getById(
          this.Cupones,
          "id",
          idSelected[0]
        );
        this.editData = prodEdit;
        this.showModal = true;
      }
      if (buttonId == "deleteCupon") {
        this.deleteCupon(idSelected[0]);
      }
    },
    optButtonClick(buttonId, ref) {},

    successData(data) {
      this.$pgsHelper.log(data);
      let sendData = {
        FechaCreacion: Date.now(),
        Mayoristas: {},
        Departamentos: {},
        Moneda: data.monedaCupon,
        Precio: parseFloat(data.costoCupon),
        Nombre: data.nombre,
        Tipo: "Cupon",
        Activo: data.status,
        UsosVenta: data.cuponesIlimitados ? null : data.cantidad,
      };
      /*let catalogo = [];
        data.productos.forEach(element => {
            catalogo.push({
                    Id: element.id,
                    CantVenta: element.CantidadCupon,
                    MndaContable: "USD",
                    MndaMayorista: "USD",
                    Tipo:element.Tipo,
                    Origen: element.Origen,
                    PrcoContable: element.PrecioContable,
                    PrcoMayorista: element.PrecioMayorista,
                    }
            );  
        });*/
      sendData.Catalogo = data.productos;
      if (this.series) {
        sendData.Mayoristas["SELF"] = true;
        sendData.Subtipo = "Rondas";
      } else {
        sendData.Mayoristas[data.mayorista] = true;
      }

      sendData.Departamentos[this.MainDepartamento] = true;
      this.$pgsHelper.log(sendData);
      if (data.Id == "" || !data.Id) {
        this.createCupon(sendData);
      } else {
        sendData.Id = data.Id;
        this.editCupon(sendData);
      }
    },
    createCupon(datos) {
      this.$swal({
        title: "¿Deseas agregar este cupón?",
        text: "Podras editarlo cuando quieras",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-crearCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          // this.$emit('reloadClient');
          if (result.value.data.ok) {
            this.$swal({
              allowOutsideClick: false,
              title: "Guardado",
              text: "El cupón se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCupons();
            });
          } else {
            this.$swal(
              "Error guardando Datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteCupon(id) {
      let datos = { Id: id, Departamento: this.MainDepartamento };
      this.$swal({
        title: "¿Deseas eliminar este cupón?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-eliminarCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "El cupón se elimino correctamente",
              "El cupón se elimino correctamente",
              "success"
            );
            this.getCupons();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    editCupon(datos) {
      this.$swal({
        title: "¿Deseas editar el cupón?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-editarCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              allowOutsideClick: false,
              title: "Guardado",
              text: "El cupón se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCupons();
            });
          } else {
            this.$swal(
              "Error guardando información",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    toggleModal(open) {
      this.showModal = open;
    },

    async getCupons() {
      if (!this.series) {
        const firestore = this.$store.getters.getFirebaseApp.firestore;
        let filter = [
          firestore.where("Departamentos." + this.MainDepartamento, "==", true),
          firestore.where("Subtipo", "==", null),
          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ];

        let snapshot = await firestore.queryBuilder("RVA_Cupones", filter);
        this.Cupones = snapshot.docs.map((doc) => {
          return { id: doc.ref.id, ...doc.data() };
        });
      } else {
        const firebase = this.$store.getters.getFirebaseApp.firestore;
        let snapshot = await firebase.queryBuilder("RVA_Cupones", [
          firebase.where("Departamentos." + this.MainDepartamento, "==", true),
          firebase.where("Subtipo", "==", "Rondas"),
          firebase.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ]);
        const cupones = snapshot.docs.map((doc) => {
          return { id: doc.ref.id, ...doc.data() };
        });
        this.Cupones = cupones;
      }
    },

    getCuponById(code) {
      let itemIndex = this.$_.findIndex(this.global_cupon, { id: code });
      if (itemIndex >= 0) {
        return this.global_cupon[itemIndex];
      }

      return false;
    },
  },
  computed: {
    global_cupon() {
      let cup_prod = [
        {
          CantidadCupon: 1,
          Nombre: "Guante de Golf para Hombre-CC93",
          PrecioContable: 22,
          PrecioMayorista: 20,
          Origen: "-MLtKZvkWu8Ew6t9piKl",
          compId: "BHyZIJjGXIRlxsTVnJo0_-MLtKZvkWu8Ew6t9piKl",
          id: "BHyZIJjGXIRlxsTVnJo0",
        },
      ];
      let cupon = [
        {
          id: "papanoel",
          Nombre: "BDAY2020",
          Mayorista: "BestDay",
          Ilimitado: true,
          Cantidad: 2,
          CostoCupon: 1244,
          PrecioVenta: 1000,
          Productos: cup_prod,
          Estatus: true,
        },
        {
          id: "navidad",
          Nombre: "MAJESTIC2020",
          Mayorista: "Majestic Hotel",
          Ilimitado: false,
          Cantidad: 2,
          CostoCupon: 1244,
          PrecioVenta: 2000,
          Productos: cup_prod,
          Estatus: false,
        },
      ];

      //let sortReservations = this.$_.orderBy(prod,'Orden','asc');

      return cupon;
    },
  },
  watch: {},
  mounted() {
    this.getCupons();
  },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
  },
};
</script>
